import RewardCenter from './RewardCenter';

export default RewardCenter;
